import React from 'react';
import { css } from 'emotion';
import { NewPolicyCard } from '../components/NewPolicyCard';
import { Loader } from '../components/Loader';
import { QuoteCard } from '../components/QuoteCard';
import { useUserQuotes, useUserPolicies } from '../../api/api';
import { ErrorQuoteCard } from '../components/ErrorQuoteCard';

const bodyContainer = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 100%;
  padding: 2.2rem;
  @media (max-width: 767px) {
    padding: 1rem;
  }
`;

const cardContainer = css`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 100%;
  flex: 1;
  flex-wrap: wrap;
  gap: 0.75rem 4rem;
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const titleStyle = css`
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.5em;
  letter-spacing: -0.03em;
  color: var(--dark);
  margin-bottom: 2.125rem;
`;

export const MyQuotes = () => {
  const { isLoading, data: quotes } = useUserQuotes();
  const { data: policies } = useUserPolicies();
  const hasAltea =
    policies?.some(p => p.productCode === 'Altea') || quotes?.some(q => q.productCode === 'Altea');
  const canShowNewQuote = !hasAltea;

  return (
    <div className={bodyContainer}>
      <h1 className={titleStyle}>My Quotes</h1>
      <div className={cardContainer}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {quotes?.map(quote =>
              quote.status === 'error' ? (
                <ErrorQuoteCard quote={quote} key={quote.quoteRef} />
              ) : (
                <QuoteCard quote={quote} key={quote.quoteRef} />
              )
            )}
            {canShowNewQuote && <NewPolicyCard quote />}
          </>
        )}
      </div>
    </div>
  );
};
